import React, { useState, useEffect } from "react";
import "./UserMessage.scss";
import {
  IonButton,
  IonGrid,
  IonIcon,
  IonRow,
  IonSearchbar,
  IonTextarea,
} from "@ionic/react";
import { userMessageService } from "./UserMessage.service";
import Loader from "../../components/Shared/Loader/Loader";
import _, { isEmpty } from "lodash";
import { useHistory, useLocation } from "react-router";
import { chevronBackOutline, peopleOutline } from "ionicons/icons";
import { FileShareListComponentService } from "../FileShare/components/SelectUserComponent/SelectUserComponent.service";
import { FileShareFullListInterface } from "../FileShare/components/SelectUserComponent/SelectUserComponent.model";
import { utilService } from "../../services";
import UserMessageCard from "../../components/Shared/UserMessageCard/UserMessageCard";
import { useToast } from "@agney/ir-toast";
import { CONSTANTS } from "../../constants/callcentral.constants";
import InfiniteScroll from "react-infinite-scroll-component";
import DoctorList from "../../components/Shared/DoctorList/doctor-list";
import { rolePermissionsService } from "../../services/rolePermissions.service";
import SelectUserComponent from "../FileShare/components/SelectUserComponent/SelectUserComponent";
import MediaUpload from "../FileShare/components/MessageMediaUpload/MediaUpload";
import { useTranslation } from "react-i18next";

interface UserMessageProps {
  userMessageData?: any;
  onCancel: () => void;
}
const UserMessage: React.FC<UserMessageProps> = (props) => {
  const { t } = useTranslation("messages");
  const [showLoader, setShowLoader]: [boolean, Function] = useState(true);
  const [userListData, setUserListDate]: any = useState([]);
  const [selectedUsersList, setSelectedUsers]: any = useState([]);
  const [selectedUsersGuidList, setSelectedUsersGuidList]: any = useState();
  const [selectedMessage, setSelectedMessage]: any = useState([]);
  const [smsThreadID, setSMSThreadID]: any = useState();
  const [isReplyAll, setReplyAll]: any = useState(false);
  const [isSelectUser, setSelectUser]: any = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isShowUploadMediaModal, setIsShowUploadMediaModal] = useState(false);

  const [message, setMessage]: any = useState("");
  const [apiParams, setApiParams]: any = useState({});
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [selectedDoctorList, setSelectedDoctorList]: any = useState([]);
  const [userListDataNextValue, setUserListNextValue]: any = useState("");

  const [showUserComponent, setShowUserComponent]: any = useState(false);
  const [viewAttachment, setViewAttachment]: any = useState(false);
  const [isFromHome, setIsFromHome]: any = useState(false);
  const [isLoaderActive, setLoaderStatus] = useState(false);

  let history = useHistory();
  const location: any = useLocation();
  const Toast = useToast();

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    checkIfLargeScreen();
    if (location?.state?.isFromHome) {
      setIsFromHome(true);
    }
  }, []);

  useEffect(() => {
    if (isSelectUser) {
      getFileShareListDetails();
      setShowLoader(true);
    }
  }, [isSelectUser]);

  useEffect(() => {
    getFileShareListDetails();
  }, [searchText]);

  useEffect(() => {
    getSelectedUsers();
  }, [selectedUsersList]);

  useEffect(() => {
    if (!_.isEmpty(selectedMessage) && isReplyAll) {
      getSelectedMessageUser(selectedMessage);
    } else if (!_.isEmpty(selectedMessage) && !isReplyAll) {
      getMessagedUser(selectedMessage);
    }
  }, [selectedMessage]);

  useEffect(() => {
    if (
      !_.isEmpty(location.state) &&
      location.pathname === "/client/usermessages"
    ) {
      const locationDetails: any = location.state;
      setSelectedMessage(locationDetails.msgData);
      setSMSThreadID(locationDetails?.msgData?.sms_thread_id);
      setReplyAll(locationDetails.replyAll);
      setSelectUser(locationDetails.selectUser);
    }
  }, [location]);

  useEffect(() => {
    if (!_.isEmpty(props.userMessageData)) {
      setSelectedMessage(props.userMessageData.msgData);
      setReplyAll(props.userMessageData.replyAll);
      setSelectUser(props.userMessageData.selectUser);
      setSMSThreadID(props.userMessageData.msgData.sms_thread_id);
    }
  }, [props.userMessageData]);

  const setParams = (selectedMessage: any) => {
    return {
      group_sms_id: selectedMessage.group_sms_id,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  };

  const getMessagedUserParams = (selectedMessage: any) => {
    return {
      guid: selectedMessage.from_user.guid,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      reg_code: utilService.getNetwork(),
    };
  };

  async function getMessagedUser(selectedMessage: any) {
    setShowLoader(true);
    setLoaderStatus(true);
    const params = getMessagedUserParams(selectedMessage);
    const respUnitDeptListResult: any =
      await userMessageService.getMessagedUserListData(params);
    if (respUnitDeptListResult.isSuccess) {
      setSelectedUsers(respUnitDeptListResult.result);
    } else {
      console.log("error");
    }
    setShowLoader(false);
    setLoaderStatus(false);
  }

  async function getSelectedMessageUser(selectedMessage: any) {
    setShowLoader(true);
    const params = setParams(selectedMessage);
    const respUnitDeptListResult: any =
      await userMessageService.getSelectedMsgUserListData(params);
    if (respUnitDeptListResult.isSuccess) {
      setSelectedUsers(respUnitDeptListResult.result);
    } else {
      console.log("error");
    }
    setShowLoader(false);
  }

  const getFileShareListDetails = async (page: number = 1) => {
    const params: any = getFileShareDoctorListParams(page);
    const respFileShareListResult: FileShareFullListInterface =
      await FileShareListComponentService.getFileShareRecentFullListDetails(
        params,searchText
      );
    if (respFileShareListResult.isSuccess && respFileShareListResult.result) {
      if (!_.isEmpty(respFileShareListResult.result)) {
        setUserListNextValue(respFileShareListResult.result?.[0]?.next);
        if (page === 1) {
          let resultDoctorListData = [
            ...respFileShareListResult.result?.[0]?.data,
          ];

          if (selectedDoctorList) {
            let commonDoctorArrayList = resultDoctorListData.filter(function (
              doctorlistusermessageone: any
            ) {
              return selectedDoctorList.some(function (
                doctorlistusermessagetwo: any
              ) {
                return (
                  doctorlistusermessageone.guid ===
                  doctorlistusermessagetwo.guid
                );
              });
            });

            commonDoctorArrayList.map((doctorcarditem) => {
              if (doctorcarditem?.guid) {
                return (doctorcarditem.isSelected = true);
              }
            });
          }

          setUserListDate(_.cloneDeep(respFileShareListResult.result?.[0]?.data));
        } else if (selectedDoctorList) {
          let combinedUserMessageData = [
            ...userListData,
            ...respFileShareListResult.result?.[0]?.data,
          ];

          let filteredDoctorListArray = combinedUserMessageData.filter(
            (doctorlistone: any) => {
              return selectedDoctorList.some(
                (doctorlisttwo: any) =>
                  doctorlistone.guid === doctorlisttwo.guid
              );
            }
          );

          filteredDoctorListArray.map((doctorcarditem) => {
            if (doctorcarditem?.guid) {
              return (doctorcarditem.isSelected = true);
            }
          });

          setUserListDate(combinedUserMessageData);
        } else {
          setUserListDate([
            ...userListData,
            ...respFileShareListResult.result?.[0]?.data,
          ]);
        }
        // setPageNo(pageNo + 1);
      }
    } else {
      console.log("error");
      FileShareListComponentService.handleErrorResponse();
    }
    setShowLoader(false);
  };

  const getFileShareDoctorListParams = (page: any) => {
    return {
      search_name: searchText,
      page: page,
      reg_code: utilService.getNetwork(),
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  };

  const updateUserList = (data: any) => {
    const tempUsers: any = [...selectedUsersList];
    const removedObject: any = _.remove(tempUsers, { guid: data.guid });
    setSelectedUsers(tempUsers);
  };

  const sendMessage = () => {
    console.log("test ")
    replayAllMessage();
    setMessage("");
    setSearchText("");
  };

  async function replayAllMessage() {
    setShowLoader(true);
    const params = setAllReplyParams();
    const respReplyAllListResult: any =
      await userMessageService.setReplyAllData(params);
    if (respReplyAllListResult.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.GROUP_SMS_SUCCESS);
    } else {
      console.log("error");
    }
    setShowLoader(false);
  }

  async function replyMessage() {
    setShowLoader(true);
    const params = setReplyParams();
    const respReplyAllListResult: any = await userMessageService.setReplyData(
      params
    );
    if (respReplyAllListResult.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.SMS_SUCCESS);
    } else {
      Toast.error(CONSTANTS.MESSAGES.SMS_FAILED);
    }
    setShowLoader(false);
  }

  const setReplyParams = () => {
    return {
      to: selectedUsersList[0].guid,
      from: utilService.getLoggedUserGuid(),
      text: message,
      type: "sms",
      mobile_number: selectedUsersList[0].mobileNumber,
      reg_code: utilService.getNetwork(),
    };
  };

  const getSelectedUsers = () => {
    let selectedUsersGuid: any = [];
    if (isSelectUser) {
      selectedDoctorList.map((items: any) => {
        selectedUsersGuid.push(items);
      });
    } else {
      selectedUsersList.map((items: any) => {
        selectedUsersGuid.push(items);
      });
    }
    setSelectedUsersGuidList(selectedUsersGuid);
  };

  const setAllReplyParams = () => {
    let selectedUsersGuid: any = [];
    if (isSelectUser) {
      selectedDoctorList.map((items: any) => {
        selectedUsersGuid.push(items.guid);
      });
    } else {
      selectedUsersList.map((items: any) => {
        selectedUsersGuid.push(items.guid);
      });
    }
    if (!_.isEmpty(selectedMessage)) {
      return {
        message_sms: message,
        reg_code: utilService.getNetwork(),
        time: utilService.getCurrentDateAndTime(),
        users: selectedUsersGuid,
        sms_thread_id: selectedMessage.sms_thread_id,
      };
    } else {
      return {
        message_sms: message,
        reg_code: utilService.getNetwork(),
        time: utilService.getCurrentDateAndTime(),
        users: selectedUsersGuid,
      };
    }
  };

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  let doctorListMessage = {
    componentName: CONSTANTS.COMPONENTS.FILE_SHARE,
    isMultiSelectEnabled: true,
    isShowColorBadge: false,
  };

  const getSelectedDoctorList = (doctorList: any) => {
    setSelectedDoctorList(_.cloneDeep(doctorList));
  };

  const handleOnCancel = () => {
    setShowUserComponent(false);
  };

  const handleSelectedDoctors = (data: any) => {
    if (!_.isEmpty(selectedUsersList)) {
      selectedUsersList.forEach((selectedUsersListItem: any) => {
        _.remove(data, {
          guid: selectedUsersListItem.guid,
        });
      });
    }
    setSelectedUsers([...selectedUsersList, ...data]);
  };

  const onScroll = () => {
    if (!_.isEmpty(userListDataNextValue)) {
      setPageNo(pageNo + 1);
      getFileShareListDetails(pageNo + 1);
    }
  };

  const onCancelRequest = () => {
    let largeScreen = utilService.getScreenSize() === "large";
    let smallScreen = utilService.getScreenSize() === "small";
    let isOnCancelAvailable = "onCancel" in props;
    smallScreen
      ? history.goBack()
      : largeScreen && isOnCancelAvailable
      ? props.onCancel()
      : history.goBack();
    setSearchText("");
  };

  return (
    <div>
      {!showUserComponent ? (
        <div className="user-message-container">
          {!isShowUploadMediaModal && (
            <div>
              <div className="file-share-select-user-header">
                <div
                  className="back-icon"
                  onClick={() => {
                    !_.isEmpty(props.userMessageData)
                      ? props.onCancel()
                      : history.goBack();
                  }}
                >
                  <IonIcon icon={chevronBackOutline} />
                </div>
                <div className="header-label">{t("sendMessage")}</div>
                {!isSelectUser && (
                  <div className="file-share-icon-div">
                    <div
                      className="file-share-icon"
                      onClick={() => setShowUserComponent(true)}
                    >
                      <img
                        className="select-users-icon"
                        src="assets/icon/select_users_icon.svg"
                        alt="Ionic logo"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`user-selection ${
                  !isSelectUser && "user-selection-padding"
                }`}
              >
                {isLoaderActive && (
                  <div className="loader-container">
                    <Loader></Loader>
                  </div>
                )}
                {isSelectUser && (
                  <div className="file-share-list-container">
                    <div className="dropdown-main-container">
                      <div className="searchbar-containar-item">
                        <IonSearchbar
                          debounce={1000}
                          value={searchText}
                          onIonChange={(e) => {
                            setSearchText(e.detail.value!);
                          }}
                          onIonClear={(e) => {
                            setSearchText("");
                          }}
                          placeholder={t("search")}
                          type="search"
                          autocomplete="off"
                          autoCorrect="off"
                          className="searchbar"
                        ></IonSearchbar>
                      </div>
                    </div>
                    {!showLoader ? (
                      <div className="file-share-list-container">
                        <InfiniteScroll
                          dataLength={userListData.length}
                          next={() => onScroll()}
                          hasMore={true}
                          height={350}
                          loader={<div></div>}
                        >
                          <DoctorList
                            apiParams={apiParams}
                            doctorListInputData={doctorListMessage}
                            doctorListDataFromParent={userListData}
                            permissions={rolePermissions}
                            searchText={searchText}
                            getSelectedCard={getSelectedDoctorList}
                            getIsAllSelectedStatus={() => {}}
                            getSelectedCardAndSchedule={() => {}}
                            getAllCards={() => {}}
                            getAllCardsAndSchedule={() => {}}
                            isFullScreen={true}
                            hideFeatureButtons={true}
                          ></DoctorList>
                        </InfiniteScroll>
                      </div>
                    ) : (
                      <div className="loader-container">
                        <Loader></Loader>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {!_.isEmpty(selectedUsersList) && (
                <div className="user-selection-list">
                  <IonGrid>
                    <IonRow>
                      {selectedUsersList && !_.isEmpty(selectedUsersList)
                        ? selectedUsersList.map((selectedUserListItem: any) => {
                            return (
                              <UserMessageCard
                                doctorData={selectedUserListItem}
                                removedUser={updateUserList}
                                isFromHomeMessage={isFromHome}
                              ></UserMessageCard>
                            );
                          })
                        : [
                            !isLoaderActive && (
                              <div className="no-results-div">
                                <div className="input-icon  icon-no_result-div">
                                  <IonIcon icon={peopleOutline}></IonIcon>
                                </div>
                                <div className="no-results-message">
                                  {t("noUsersAdded")}
                                </div>
                              </div>
                            ),
                          ]}
                    </IonRow>
                  </IonGrid>
                </div>
              )}

              {isSelectUser && (
                <div className="message-main-container">
                  <div className="comment-box">
                    <IonTextarea
                      className="textarea-div"
                      maxlength={250}
                      placeholder={t("enterMessagePlaceholder")}
                      id="smsText"
                      onIonChange={(e) => {
                        setMessage(e.detail.value);
                      }}
                      value={message}
                    ></IonTextarea>
                  </div>

                  <div className="group-sms-button-container">
                    <div className="cancel-button-div">
                      <IonButton
                        color="medium"
                        className="button secondary-btn  btn-curved"
                        onClick={() => {
                          onCancelRequest();
                        }}
                      >
                        {t("cancel")}
                      </IonButton>
                    </div>
                    <div className="send-button-div">
                      <IonButton
                        className="submit-btn button primary-btn btn-curved"
                        onClick={() => {
                          sendMessage();
                        }}
                        disabled={
                          (isEmpty(selectedUsersList) &&
                            isEmpty(selectedDoctorList)) ||
                          isEmpty(message)
                        }
                      >
                        {t("send")}
                      </IonButton>
                    </div>
                  </div>
                </div>
              )}
              {!isSelectUser && (
                <MediaUpload
                  doctorListDataFromParent={selectedUsersGuidList}
                  isMessageComponent={true}
                  smsThread={smsThreadID}
                  onOk={() => {}}
                  onCancel={() => {
                    setIsShowUploadMediaModal(false);
                    onCancelRequest();
                  }}
                  selectedUsers={selectedUsersList}
                  isFromHomeMessage={isFromHome}
                ></MediaUpload>
              )}
            </div>
          )}
        </div>
      ) : (
        <SelectUserComponent
          onCancel={handleOnCancel}
          getSelectedCard={handleSelectedDoctors}
          isRoutedFromMessages={true}
          isMessageComponent={true}
        ></SelectUserComponent>
      )}
    </div>
  );
};

export default UserMessage;
